import { render, staticRenderFns } from "./CreateChat.vue?vue&type=template&id=601a8c92&scoped=true"
import script from "./CreateChat.vue?vue&type=script&lang=js"
export * from "./CreateChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a8c92",
  null
  
)

export default component.exports